import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _br;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { getSeoMeta } from 'selectors';
import { META_FOR_RKO_PAGE } from 'constants/index';
import { useSelectorProps } from './useSelectorProps';
export var useSeoMeta = function useSeoMeta(meta, values) {
  var _ref = meta || META_FOR_RKO_PAGE,
      titleID = _ref.titleID,
      descriptionID = _ref.descriptionID,
      metaTitleID = _ref.metaTitleID,
      metaDescriptionID = _ref.metaDescriptionID;

  var _useIntl = useIntl(),
      formatMessage = _useIntl.formatMessage;

  var selectorProps = useSelectorProps();

  var _useSelector = useSelector(function (state) {
    return getSeoMeta(state, selectorProps);
  }),
      pageTitle = _useSelector.pageTitle,
      pageDescription = _useSelector.pageDescription,
      metaTitle = _useSelector.metaTitle,
      metaDescription = _useSelector.metaDescription;

  var formattedPageTitle = useMemo(function () {
    return pageTitle || formatMessage({
      id: titleID
    }, values);
  }, [pageTitle, titleID, values]);
  var formattedPageDescription = useMemo(function () {
    return pageDescription || formatMessage({
      id: descriptionID
    }, _objectSpread(_objectSpread({}, values), {}, {
      br: _br || (_br = /*#__PURE__*/_jsx("br", {}))
    }));
  }, [pageTitle, titleID, values]);
  var formattedMetaTitle = useMemo(function () {
    return metaTitle || formatMessage({
      id: metaTitleID
    }, values);
  }, [metaTitle, metaTitleID, values]);
  var formattedMetaDescription = useMemo(function () {
    return metaDescription || formatMessage({
      id: metaDescriptionID
    }, values);
  }, [metaDescription, metaDescriptionID, values]);
  return {
    pageTitle: formattedPageTitle,
    pageDescription: formattedPageDescription,
    metaTitle: formattedMetaTitle,
    metaDescription: formattedMetaDescription
  };
};
export default useSeoMeta;